import styled from "styled-components";

export const AvtaleGiroButton = styled.button`
  padding: 16px;
  background: none;
  border: none;
  margin: 30px auto;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: right;
  width: 80%;
  background: rgba(93, 56, 0, 1);
  border-radius: 5px;
  color: white;
  font-family: "Roboto";
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;
